import axios from 'axios'

async function getXsrfToken() {
    const response = await axios.get('/api/session/csrf-token')
    return response?.data?.token || null
}

async function requestHeaders(oktaToken) {
    const xsrfToken = await getXsrfToken()
    if (!xsrfToken) {
        throw 'Missing XSRF-TOKEN'
    }
    const headers = {
        'X-XSRF-TOKEN': xsrfToken
    }
    if (oktaToken) {
        headers.Authorization = `Bearer ${oktaToken}`
    }

    return {
        headers
    }
}

export const getViews = async ({ commit }, oktaToken) => {
    try {
        const response = await axios.get('/api/views', await requestHeaders(oktaToken))

        console.log(response)
        if (response.status === 200) {
            commit('UPDATE_VIEWS', response.data)
            commit('UPDATE_SUMMARY_VIEW', response.data)
            return response
        }

        throw response.data.message
    }
    catch (ex) {
        console.error(ex)
    }
}

export const getAuthToken = async (_, oktaToken) => {
    try {
        const response = await axios.get('/api/authentication', await requestHeaders(oktaToken))

        console.log(response)
        if (response.status === 200) {
            return response
        }

        throw response.data.message
    }
    catch (ex) {
        console.error(ex)
    }
}

export const getConfiguration = async ({ commit }) => {
    try {
        const response = await axios.get('/api/configuration', await requestHeaders())

        console.log(response)
        if (response.status === 200) {
            commit('UPDATE_CONFIGURATION', response.data)
            return response
        }

        throw response.data.message
    }
    catch (ex) {
        console.error(ex)
    }
}

export const getSession = async () => {
    try {
        const response = await axios.get('/api/session/get', await requestHeaders())

        console.log(response)
        if (response.status === 200) {
            return response;
        }

        throw response.data.message
    }
    catch (ex) {
        console.error(ex)
    }
}

export const checkSession = async () => {
    try {
        const response = await axios.get('/api/session/check', await requestHeaders())

        console.log(response)
        if (response.status === 200) {
            return response;
        }

        throw response.data.message
    }
    catch (ex) {
        console.error(ex)
    }
}

export const clearSession = async () => {
    try {
        const response = await axios.get('/api/session/clear', await requestHeaders())

        console.log(response)
        if (response.status === 200) {
            return response;
        }

        throw response.data.message
    }
    catch (ex) {
        console.error(ex)
    }
}

export const submitSimulatorParams = async (_, { payload, oktaToken }) => {
    try {
        //const response = await axios.post('/api/simulator', payload, requestHeaders(oktaToken))
        const response = await axios.get(`/api/simulator?data=${encodeURIComponent(JSON.stringify(payload))}`, await requestHeaders(oktaToken))

        if (response.status === 200) {
            return response.data.filterResults
        }

        throw response.data.message
    }
    catch (ex) {
        console.error(ex)
    }
}

export const submitSaveFilterParams = async (_, { payload, oktaToken }) => {
    try {
        const response = await axios.get(`/api/savefilter?data=${encodeURIComponent(JSON.stringify(payload))}`, await requestHeaders(oktaToken))
        if (response.status === 200) {
            return response
        }

        throw response.data.message
    }
    catch (ex) {
        console.error(ex)
    }
}

export const getPreviousFilterParams = async (_, { payload, oktaToken }) => {
    try {
        const response = await axios.get(`/api/savefilter/previousfilter?filterId=${encodeURIComponent(payload)}`, await requestHeaders(oktaToken))
        if (response.status === 200) {
            return response.data
        }
    }
    catch (ex) {
        console.error(ex)
    }
}

export const logWarning = async (_, warning) => {
    try {
        const response = await axios.post('/api/logging/warning', { message: warning }, await requestHeaders())

        if (response.status === 204) {
            return response
        }

        throw response.data.message
    }
    catch (ex) {
        console.error(ex)
    }
}

export const logEvent = async (_, event) => {
    try {
        const response = await axios.post('/api/logging/event', { message: event }, await requestHeaders())

        if (response.status === 204) {
            return response
        }

        throw response.data.message
    }
    catch (ex) {
        console.error(ex)
    }
}

export const getUser = async ({ commit }, oktaToken) => {
    try {
        const response = await axios.get('/api/authentication/user', await requestHeaders(oktaToken))

        console.log(response)
        if (response.status === 200) {
            commit('UPDATE_USER', response.data)
            return response
        }

        throw response.data.message
    }
    catch (ex) {
        console.error(ex)
    }
}

export const getInsights = async ({ commit }, oktaToken) => {
    try {
        const response = await axios.get('/api/insights', await requestHeaders(oktaToken))

        console.log(response)
        if (response.status === 200) {
            commit('UPDATE_INSIGHTS', response.data)
            return response
        }

        throw response.data.message
    }
    catch (ex) {
        console.error(ex)
    }
}

export const getFilterList = async ({ commit }, oktaToken) => {
    try {
        const response = await axios.get('/api/simulator/filterList', await requestHeaders(oktaToken))

        console.log(response)
        if (response.status === 200) {
            commit('GET_FILTERLIST', response.data)
            return response.data
        }

        throw response.data.message
    }
    catch (ex) {
        console.error(ex)
    }
}

export const getAggregatorList = async ({ commit }, oktaToken) => {
    try {
        const response = await axios.get('/api/simulator/aggregatorList', await requestHeaders(oktaToken))

        console.log(response)
        if (response.status === 200) {
            commit('GET_AGGREGATOR_LIST', response.data)
            return response.data
        }

        throw response.data.message
    }
    catch (ex) {
        console.error(ex)
    }
}

export const GetFilterSet = async ({ commit }, oktaToken) => {
    try {
        const response = await axios.get('/api/SaveFilter/FilterSet', await requestHeaders(oktaToken))

        console.log(response)
        if (response.status === 200) {
            commit('GET_FILTERSET_LIST', response.data)
            return response.data
        }

        throw response.data.message
    }
    catch (ex) {
        console.error(ex)
    }
}

export const submitUpdateFilterParams = async (_, { payload, oktaToken }) => {
    try {
        const response = await axios.get(`/api/savefilter/UpdateFilter?data=${encodeURIComponent(JSON.stringify(payload))}`, await requestHeaders(oktaToken))
        if (response.data.statusCode === 200) {
            return response
        }

        throw response.data.message
    }
    catch (ex) {
        console.error(ex)
    }
}

export const fetchAscendMarketingFlag = async ({ commit },oktaToken) => {
    try {
        const response = await axios.get('/api/featureflags/getFeatureFlag', await requestHeaders(oktaToken));
        if (response.status === 200 && typeof response.data.enabled !== 'undefined') {
            commit('SET_FEATURE_FLAG', { key: 'ascendMarketing', value: response.data.enabled });
            
            return response.data.enabled;
        }
        throw response.data.message || 'Failed to fetch feature flag';
    } catch (ex) {
        console.error(ex);
    }
}

export const fetchATPFlag = async ({ commit }, oktaToken) => {
    try {
        const response = await axios.get('/api/featureflags/getATPFeatureFlag', await requestHeaders(oktaToken));
        if (response.status === 200 && typeof response.data.enabled !== 'undefined') {
            commit('SET_ATP_FEATURE_FLAG', { key: 'atpliteheader', value: response.data.enabled });
            return response.data.enabled;
        }
        throw response.data.message || 'Failed to fetch feature flag';
    } catch (ex) {
        console.error(ex);
    }
}